import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "map" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "map-title" }, "抽取游玩地图", -1)
const _hoisted_3 = { class: "map-roll-list" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "map-text" }
const _hoisted_7 = ["disabled"]

import {
  buttonDisabled,
  opacityValue,
  mapList,
  rollMap,
  initMap
} from "@/assets/ts/map";
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MapView',
  setup(__props) {

const mapListRef = ref<HTMLStyleElement>();
const mapNameRef = ref<HTMLStyleElement>();

initMap();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "map-list",
        ref_key: "mapListRef",
        ref: mapListRef
      }, [
        _createElementVNode("img", {
          src: require('@/assets/images/maps/raid/国王的陨落.jpg'),
          alt: "国王的陨落.jpg"
        }, null, 8, _hoisted_4),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mapList), (map, index) => {
          return (_openBlock(), _createElementBlock("img", {
            src: require('@/assets/images/maps/raid/' + map.name + '.jpg'),
            key: index,
            alt: map.name + '.jpg'
          }, null, 8, _hoisted_5))
        }), 128))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h1", {
        ref_key: "mapNameRef",
        ref: mapNameRef,
        style: _normalizeStyle({ opacity: _unref(opacityValue), 'transition': 'opacity 1s' })
      }, "国王的陨落", 4)
    ]),
    _createElementVNode("button", {
      class: "map-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(rollMap)(mapListRef.value, mapNameRef.value))),
      disabled: _unref(buttonDisabled)
    }, "抽取地图", 8, _hoisted_7)
  ]))
}
}

})